import * as React from 'react';

// PACKAGES
import { Link, useLocation } from 'react-router-dom';

// UTILS
import { listenForOutsideClicks } from '../utils';

// REDUX
import { useAppSelector, useAppDispatch } from '../store';
import UserSlice from '../store/slices/User';

// COMPONENTS
import CircleImage from './CircleImage';
import Button from '../components/Button';

// ICONS
import { ReactComponent as LoginIcon } from '../assets/svg/login.svg';
import { ReactComponent as ArrowDownIcon } from '../assets/svg/arrow-down.svg';
import { ReactComponent as ArrowUpIcon } from '../assets/svg/arrow-up.svg';
import { ReactComponent as SettingsIcon } from '../assets/svg/settings.svg';
import { ReactComponent as LogOutIcon } from '../assets/svg/logout.svg';

// TYPES
import { DomainProfileType } from '../api/models';

const AccountMenu: React.FC = () => {
	// Detect pathname on the url
	const { pathname } = useLocation<string>();

	const dispatch = useAppDispatch();
	const user = useAppSelector(({ user }) => user);

	const isSuperAdmin = user.activeProfileType === DomainProfileType.SuperAdministrator;

	const isActiveOrganisation = useAppSelector((state) => state.user.isOrganisationActive);

	const profileImage = user.profileImage;

	const [isAccountMenuOpen, setIsAccountMenuOpen] = React.useState<boolean>(false);
	const menuRef = React.useRef(null);
	const menuToggle = () => setIsAccountMenuOpen(!isAccountMenuOpen);

	listenForOutsideClicks(menuRef, isAccountMenuOpen, setIsAccountMenuOpen);

	const doLogout = () => {
		dispatch(UserSlice.actions.logOut());
	};

	if (!user.loggedIn) {
		return (
			<div className="login-menu">
				<div className="menu-wrapper">
					{pathname !== '/login' && (
						<Link to="/login" className="btn btn-text-icon">
							<LoginIcon /> Log in
						</Link>
					)}
				</div>
			</div>
		);
	} else {
		return (
			<div className="account-menu">
				<div className="menu-wrapper">
					<div className="account-info" onClick={menuToggle}>
						<CircleImage isColorBorder={true} src={profileImage} alt="profile picture" size={32} />

						<h4 className="account-name">
							{user.firstName} {user.lastName}
						</h4>

						<button type="button" ref={menuRef} className="dropdown-wrapper">
							{isAccountMenuOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
						</button>
					</div>

					{isAccountMenuOpen && (
						<div className={`my-account-menu ${isAccountMenuOpen ? 'show' : ''} `}>
							{isActiveOrganisation && !isSuperAdmin && (
								<Link className="my-account-menu-item" onClick={menuToggle} to="/my-account">
									<SettingsIcon /> My Account
								</Link>
							)}

							<Button className="my-account-menu-item no-border" onClick={doLogout}>
								<LogOutIcon /> Logout
							</Button>
						</div>
					)}
				</div>
			</div>
		);
	}
};

export default AccountMenu;
